import * as _ from "lodash";
import * as angular from "angular";
import { Campaign } from "../../../../models/campaign.model";
import { Organisation } from "../../../../models/organisation.model";
import { Plan } from "../../../../models/plan.model";

let AdminLimitsComponent = {
    selector: "vcAdminLimits",
    templateUrl:
        "/angular/components/admin/dialogs/sections/admin-limits.component.html",
    bindings: {
        limits: "=",
        campaign: "=?",
        organisation: "=?",
    },
    controller: class AdminLimitsController {
        // * bindings for typescript compiler *
        public limits: any;
        public campaign?: Campaign;
        public organisation?: Organisation;
        // ************************************

        private originalLimits: any;
        public tab: string;

        private readonly $scope: any;
        public __env: any;

        constructor($scope: any, __env: any) {
            this.$scope = $scope;
            this.__env = __env;
            this.tab = "included";
        }

        $onInit() {
            if (this.campaign) {
                this.$scope.$watch(
                    () => this.campaign.plan,
                    (newValue: any, oldValue: any) => {
                        if (newValue != oldValue) {
                            this.setLimitsBasedOnPlan(newValue);
                        }
                    },
                    true
                );
            }

            this.originalLimits = this.campaign
                ? _.cloneDeep(this.campaign.limits)
                : null;
        }

        setLimitsBasedOnPlan(plan: Plan): void {
            if (plan.cpname == "Legacy" || plan.cpname == "Essentials") {
                this.campaign.limits.customfields =
                    this.originalLimits.customfields;
                this.campaign.limits.superusers =
                    this.originalLimits.superusers;
                this.campaign.limits.users = this.originalLimits.users;
            } else {
                if (this.campaign && this.campaign.limits) {
                    this.campaign.limits.customfields = plan.customfieldslimit;
                    this.campaign.limits.superusers = plan.superuserslimit;
                    this.campaign.limits.users = plan.userslimit;
                }
            }
        }
    },
};

angular
    .module("admin")
    .component(AdminLimitsComponent.selector, AdminLimitsComponent);
